import { useAddArticleToCart } from '@lib/hooks/use-add-article-to-cart'
import { useCart } from '@lib/hooks/useCart'
import { useTranslation } from 'next-i18next'
import { Article } from '@generated'
import { Button } from '@components/rolex-ui/Button'
import { cn } from '@lib/cn'
import { useRolexEventTracking } from '@lib/hooks/use-rolex-track-events'

type CartActionsProps = {
  data: Article
}

const CartActions = ({ data }: CartActionsProps) => {
  const { handleAddArticleToCart } = useAddArticleToCart()
  const { t } = useTranslation(['other', 'rolex'])
  const { id } = data
  const { track } = useRolexEventTracking()

  const cart = useCart()
  const hasItemInCart = cart?.items.some((item) => item.articleId === data.id)

  return (
    <div
      className={cn(
        'mb-[40px] mt-[20px] flex flex-row gap-4',
        'md:mb-[30px]',
        'lg:mb-[40px] lg:mt-[30px]',
      )}
    >
      <Button
        as="button"
        variant="primary"
        disabled={hasItemInCart}
        onClick={() => {
          track('addToBag')
          handleAddArticleToCart({ articleId: id })
        }}
      >
        {hasItemInCart ? t('addedToCart', { ns: 'other' }) : t('addToCartAlt', { ns: 'other' })}
      </Button>
    </div>
  )
}

export default CartActions
